export class ConfigDB {
	static data = {
		settings: {
			layout_type: 'ltr',
			sidebar: {
				type: 'compact-wrapper',
			},
			sidebar_setting: 'default-sidebar',
		},
		color: {
			primary_color: '#f4af17',
			secondary_color: '#131e2c',
			mix_background_layout: 'light-only',
		},
		router_animation: 'fadeIn'
	}
}
export default ConfigDB;




